import angular from 'angular';
let inject = ['$scope', '$uibModalInstance', 'product', 'CartService', 'SessionService', '$state'];

class ModalConfirmationController {
  constructor ($scope,$uibModalInstance, product, CartService, SessionService, $state) {
    this.$scope = $scope;
    this.productAdded = angular.copy(product);
    this.$uibModalInstance = $uibModalInstance;
    this.$state = $state;
    this.SessionService = SessionService;
    this.CartService = CartService;
    this.itemQuantityToAdd = 1;
    this.user = {};
  }

  $onInit(){
    this.SessionService.getGlobals().then(response => {
      let cartId = this.SessionService.get('cartId') || '';
      let userId = '';
      try{ userId = response.currentUser.userId; }
      catch(e){}
      let clientPriceListName = '';
      try {
        clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
      } catch(e) {}

    
      let dataCart = this.SessionService.loadCartInfo(null,'get')

      if(!dataCart || angular.isUndefined(dataCart)){
        this.CartService.getCart(cartId, userId, clientPriceListName).then(response => {
          this.cart = response;
          this.product = this.cart.items.filter(val => val.id === this.productAdded.id)[0];

        })
      }else{
        this.cart = dataCart;
        this.product = this.cart.items.filter(val => val.id === this.productAdded.id)[0];
      }


    }).catch(reason => {
      return null;
    });
  }

  goToCart(){
    this.cancel();
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  
}

ModalConfirmationController.$inject = inject;

export default ModalConfirmationController ;



// WEBPACK FOOTER //
// ./www/components/catalog/modal-confirmation/modal-confirmation.controller.js